"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BoomiOrderPaymentFailureSchema = void 0;
const boomi_order_default_1 = require("./boomi-order-default");
const EVENT_INFO_DEFINITION = {
    properties: {
        autoRenewStatus: {
            type: 'boolean'
        },
        gracePeriodExpires: {
            type: 'string',
            minLength: 10
        },
        retryCount: {
            type: 'number'
        }
    },
    required: [
        'autoRenewStatus',
        'gracePeriodExpires',
        'retryCount'
    ],
    type: 'object',
};
const EVENT_INFO_PROPERTY = {
    $ref: '#/definitions/EventInfo'
};
const EVENT_TYPE_DEFINITION = {
    enum: [
        'PAYMENT_FAILURE'
    ],
    type: 'string'
};
const EVENT_TYPE_PROPERTY = {
    $ref: '#/definitions/EventType'
};
exports.BoomiOrderPaymentFailureSchema = {
    ...boomi_order_default_1.BoomiOrderDefaultSchema,
    definitions: {
        ...boomi_order_default_1.BoomiOrderDefaultSchema.definitions,
        EventInfo: EVENT_INFO_DEFINITION,
        EventType: EVENT_TYPE_DEFINITION
    },
    properties: {
        ...boomi_order_default_1.BoomiOrderDefaultSchema.properties,
        eventInfo: EVENT_INFO_PROPERTY,
        eventType: EVENT_TYPE_PROPERTY,
    },
};
//# sourceMappingURL=data:application/json;base64,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